import React from 'react';
import { Link } from 'react-router-dom';
import Carousel from 'nuka-carousel';

import styles from './FlightCardList.module.css';

import unitedSmall from './images/small/longhaul/small_long1.jpg';
import deltaSmall from './images/small/longhaul/small_long2.jpg';
import surfairSmall from './images/small/longhaul/small_long4.jpg';
import surfairOutboundSmall from './images/small/smallcard4.png';

import virginSmall from './images/small/longhaul/small_long5.jpg'; // this card is a special branded one - dont use it in the random lists

import LargeFlightCard from '../LargeFlightCard/LargeFlightCard';

const cards = { unitedSmall, deltaSmall, surfairSmall, virginSmall, surfairOutboundSmall };

const smallCardsSorted = [unitedSmall, deltaSmall, surfairSmall, unitedSmall, deltaSmall, surfairSmall, unitedSmall, deltaSmall, surfairSmall, unitedSmall, deltaSmall, surfairSmall, ];
const smallCardsDefault = [surfairSmall, deltaSmall, unitedSmall, surfairSmall, deltaSmall, unitedSmall, surfairSmall, deltaSmall, unitedSmall, surfairSmall, deltaSmall, unitedSmall, ];

const airlines = ["airCanada", "jetSuite", "fiji", "surfair", "united", "virgin" ];
const prices = [280, 340, 260, 340, 300, 250];
const durations = ['1h 10m', '2h 0m', '1h 30m', '2h 30m', '1h 15m', '1h 45m'];
const numberOfFlights = [1, 3, 4, 8, 3, 5];
//const departures = ['Fri 7:15am', 'Sat 8:30am', 'Thur 9:00am', 'Fri 9:45 am', 'Wed 2:00pm', 'Fri 3:45pm'];
//const arrivals = ['Mon 9:15am', 'Wed 8:30am', 'Sat 4:30pm', 'Fri 1:30pm', 'Sat 9:00am', 'Sun 9:30am'];

export const FlightCardSmall = ({direction="outbound", airline="united", onClicked }) => {
  console.log(`cards[${airline}Small`);
  return <li className={styles.flightCardSmall} ><Link onClick={onClicked} to={`/flight/0/${direction}`}><img src={cards[`${airline}Small`]} alt="" /></Link></li>
};  

export const FlightCardListSmall = ({count = 3, sorted = false, direction = "outbound", onClicked }) => {
  const cards = [];
  for (let i = 0; i < count; i++) {
    cards.push(<li className={styles.flightCardSmall} key={`flightCardSmall${i}`} ><Link onClick={onClicked} to={`/flight/${i}/${direction}`}><img src={sorted ? smallCardsSorted[i] : smallCardsDefault[i]} alt="" /></Link></li>);
  }

  return (
    <ul className={styles.smallFlightCardListWrapper} >
      {cards}
    </ul>
  );
};

export const renderFlightCardDecorator = () => {
  let length = airlines.length;
  let decorators = [];
  for(var i = 0; i <= length; i++){
    decorators.push(
      <div className={styles.lardCardCarouselDecorator}/>
    )
  }

  return decorators;
}






export const FlightCardListLarge = ({count = 3, direction = "outbound"}) => {
  const cards = [];
  for (let i = 0; i < count; i++) {    
    const cardEl = (
      <Link to={`/flight/${i}/${direction}`} key={`flightCardLarge${i}`}>
        <LargeFlightCard airline={airlines[i]} price={prices[i]} duration={durations[i]} numberOfFlights={numberOfFlights[i]} />
      </Link>
    );
    cards.push(cardEl);
  }
  return (
    <div className={styles.largeCardCarouselWrapper} >
      <Carousel
        renderBottomCenterControls={null}
        renderCenterLeftControls={null}
        renderCenterRightControls={null}
        initialSlideHeight={480}
        dragging>
          {cards}
      </Carousel>
    </div>
  );
};




// WEBPACK FOOTER //
// ./src/components/FlightCardList/FlightCardList.jsx